import { useMutation } from '@percent/partner-dashboard/common/hooks'
import { useServices } from '@percent/partner-dashboard/context/serviceContext/ServiceContext'

export type ArchiveGivingActionError = Record<'code' | 'message' | 'title', string>

export type UseArchiveGivingActionProps = Readonly<{
  actionId: string | undefined
  onArchived: () => void
  onError: (error: ArchiveGivingActionError) => void
}>

export type UseArchiveGivingActionReturn = Readonly<{
  isLoading: boolean
  archiveGivingAction: () => void
}>

const defaultError: ArchiveGivingActionError = {
  code: 'error',
  message: 'error',
  title: 'error'
}

export const useArchiveGivingAction = ({
  actionId,
  onArchived,
  onError
}: UseArchiveGivingActionProps): UseArchiveGivingActionReturn => {
  const { givingActionsService } = useServices()

  const [{ isLoading }, { apiFunc: archiveGivingAction }] = useMutation(
    givingActionsService.archiveGivingAction,
    () => {
      onArchived()
    },
    error => {
      if (error) {
        onError(error.response?.data?.error ?? defaultError)
      }
    }
  )

  return {
    isLoading,
    archiveGivingAction: () => {
      if (actionId) {
        archiveGivingAction(actionId)
      }
    }
  }
}
